import React from 'react';
import { Section } from '../../../shared';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { SubscribeBlockFeature } from '../../../features';
import SuggestEventCard from '../../../shared/SuggestEventCard/SuggestEventCard';

export function CanBeInterestModule({
  title,
  description,
  leadData,
  events = [],
  setCurrentEvent,
}) {
  const isMd = useMediaQuery((theme) => theme.breakpoints.down('md'));

  return (
    <Grid container columnSpacing={3}>
      <Grid item xs={12} lg={4} sx={{}}>
        <Typography variant="desktopH2" color={'kit.text.main'}>
          {title}
        </Typography>
        <Typography
          component={'div'}
          variant="dektopP2"
          sx={{ mt: { xs: 2 }, maxWidth: 350 }}
        >
          {description}
        </Typography>
        {isMd && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', lg: 'row' },
              gap: 2,
              overflowX: 'scroll',
              mt: 3,
            }}
          >
            {events[0] && (
              <SuggestEventCard
                {...events[0]}
                clickHandler={() => setCurrentEvent(events[0])}
                isWide
              />
            )}
            {events[1] && (
              <SuggestEventCard
                {...events[1]}
                clickHandler={() => setCurrentEvent(events[1])}
                isWide
              />
            )}
          </Box>
        )}

        <SubscribeBlockFeature leadData={leadData} ymSubmitEventType={{}} />
      </Grid>
      {!isMd && (
        <>
          <Grid item xs={12} lg={4} sx={{}}>
            {events[0] && (
              <SuggestEventCard
                {...events[0]}
                clickHandler={() => setCurrentEvent(events[0])}
                isWide
              />
            )}
          </Grid>
          <Grid item xs={12} lg={4} sx={{}}>
            {events[1] && (
              <SuggestEventCard
                {...events[1]}
                clickHandler={() => setCurrentEvent(events[1])}
                isWide
              />
            )}
          </Grid>
        </>
      )}
    </Grid>
  );
}

export default function CanBeInterest(props) {
  const isMd = useMediaQuery((theme) => theme.breakpoints.down('md'));
  return (
    <Section>
      <CanBeInterestModule {...props} />
    </Section>
  );
}
